export const SITE_NAME = '天天漫画';

// 站点分享图 / Logo（来源于官方 favicon，可追溯的合法图片 URL）
export const SITE_IMAGE =
  '/images/logo/logo.webp';

// 站点真实域名来源：环境变量 VITE_SITE_URL，缺失时回退到当前浏览器 origin
export function getSiteUrl(): string {
  const env = (import.meta.env.VITE_SITE_URL as string | undefined) || '';
  const base = env.replace(/\/+$/, '');
  if (base) return base;
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
}

export const seoConfig: Record<string, SeoData> = {
  '/': {
    title: '天天漫画 - 海量优质漫画随心看',
    description:
      '天天漫画汇集海量正版优质漫画，涵盖热血、恋爱、悬疑、搞笑等全品类，每日同步更新热门连载与经典神作。清爽阅读界面，智能分类推荐，让您随时随地畅享漫画世界。',
    keywords: '天天漫画',
  },
  '/download': {
    title: '天天漫画下载 - 天天漫画',
    description:
      '天天漫画官方正版下载，全面支持安卓、iOS、鸿蒙及Windows四大平台。海量热门漫画免费畅读，每日同步更新，分类清晰，阅读流畅。快来天天漫画APP下载，随时随地享受追漫乐趣吧。',
    keywords: '天天漫画下载,天天漫画APP下载,天天漫画官方正版下载',
  },
  '/features': {
    title: '天天漫画功能亮点 - 天天漫画',
    description:
      '天天漫画支持互动社区、智能推荐和横竖屏切换，更新实时提醒，界面清爽无弹窗。无论安卓、iOS、鸿蒙还是Windows，都能享受流畅阅读。',
    keywords: '天天漫画功能亮点',
  },
  '/hot-comics': {
    title: '天天漫画热门排行榜 - 天天漫画',
    description:
      '天天漫画精选全网热门漫画，按阅读量、评分与口碑综合排序，涵盖恋爱、热血、悬疑、奇幻等全品类，发现下一部追漫目标。',
    keywords: '天天漫画热门排行榜',
  },
  '/reviews': {
    title: '天天漫画用户好评 - 天天漫画',
    description:
      '天天漫画以优质阅读体验与丰富漫画资源赢得千万用户信赖，综合评分4.9，用户好评率99%，看看真实用户怎么说。',
    keywords: '天天漫画用户好评',
  },
  '/about': {
    title: '关于我们 - 天天漫画',
    description:
      '天天漫画致力于打造优质的漫画阅读平台，从热血少年漫到细腻少女漫，我们用心梳理每一部作品，让好漫画被更多同好看见。',
    keywords: '关于我们',
  },
  '/help': {
    title: '常见问题与使用指南 - 天天漫画',
    description:
      '天天漫画帮助中心，解答下载安装、账号注册、阅读设置、离线缓存等常见问题，快速解决使用过程中的疑问。',
    keywords: '天天漫画帮助,常见问题,使用指南',
  },
  '/categories': {
    title: '全品类漫画 - 天天漫画',
    description:
      '天天漫画收录12大品类、10万+部优质漫画，涵盖热血、恋爱、悬疑、奇幻、校园等全类型，一站读尽心仪之作。',
    keywords: '天天漫画分类',
  },
  '/schedule': {
    title: '追更日历 - 天天漫画',
    description:
      '天天漫画每日多时段更新，查看本周连载节奏与新番预告，提前掌握心仪作品的更新计划，不错过每一话。',
    keywords: '天天漫画追更日历',
  },
  '/creator': {
    title: '创作者平台 - 天天漫画',
    description:
      '天天漫画创作者平台面向全球漫画家开放，提供丰厚收益分成、海量流量扶持与一站式创作工具，让每一个好故事被看见。',
    keywords: '天天漫画创作者平台',
  },
  '/careers': {
    title: '加入我们 - 天天漫画',
    description:
      '天天漫画正在快速成长，热招技术、内容、设计、运营等岗位，加入热爱漫画的团队，一起做点有意思的事。',
    keywords: '加入我们',
  },
  '/privacy': {
    title: '隐私政策 - 天天漫画',
    description: '天天漫画隐私政策，了解我们如何收集、使用和保护您的个人信息，保障您的合法权益。',
    keywords: '天天漫画,隐私政策',
  },
  '/terms': {
    title: '用户协议 - 天天漫画',
    description: '天天漫画用户协议，明确您使用天天漫画服务时的权利义务与使用规范。',
    keywords: '天天漫画,用户协议',
  },
};